import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        // Authentication check
        if (username === 'ilayda@roasberry.com' && password === 'TestRoasberry!') {
            onLogin(true);
            navigate('/create-blog'); // Navigate to the create blog page
        } else {
            alert('Invalid credentials');
        }
    };

    return (
        <div className='mt-[30vh] flex flex-col items-center justify-center'>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div>
                    <p>USERNAME</p>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className='bg-transparent border border-[#FFFFFF]'
                    />
                </div>
                <div>
                    <p>PASSWORD</p>
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className='bg-transparent border border-[#FFFFFF]'
                    />
                </div>
                <button type="submit">Login</button>
            </form>
        </div>
    );
}

export default Login;
